
import React from 'react';
import { Calendar, Package, Truck } from 'lucide-react';
import OrderStatusBadge from '../OrderStatusBadge';
import { Order } from '../order-types';
import ShippingDetailsDisplay from '../ShippingDetails';

interface OrderHeaderProps {
  order: Order;
}

const OrderHeader = ({ order }: OrderHeaderProps) => {
  return (
    <div className="flex flex-col space-y-3">
      <div className="flex flex-col sm:flex-row gap-4">
        <div className="w-full sm:w-24 h-24 bg-gray-100 relative flex-shrink-0 rounded-md overflow-hidden">
          {order.listings?.images && order.listings.images[0] ? (
            <img 
              src={order.listings.images[0]} 
              alt={order.listings.title} 
              className="w-full h-full object-cover"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center bg-gray-200 text-gray-400">
              No image
            </div>
          )}
        </div>
        
        <div className="flex-1">
          <div className="flex justify-between items-start">
            <div>
              <h3 className="font-semibold text-lg">{order.listings?.title}</h3>
              <p className="text-green-600 font-medium mt-1">
                {order.amount} {order.currency}
              </p>
            </div>
            <div>
              <OrderStatusBadge status={order.status} />
            </div>
          </div>
          
          <div className="mt-2 space-y-1 text-sm text-gray-600">
            <p className="flex items-center">
              <Calendar className="h-3.5 w-3.5 mr-1.5 text-gray-500" />
              <span>Data: {new Date(order.created_at).toLocaleDateString('sq-AL')}</span>
            </p>
            {order.shipping_method && (
              <p className="flex items-center">
                <Package className="h-3.5 w-3.5 mr-1.5 text-gray-500" />
                <span>Metoda e dërgimit: {order.shipping_method}</span>
              </p>
            )}
          </div>
        </div>
      </div>
      
      {/* Show shipping details if available */}
      {order.status === 'shipped' && (
        <ShippingDetailsDisplay shippingDetails={order.shipping_details} />
      )}
    </div>
  );
};

export default OrderHeader;
